import * as React from 'react';
import { useState } from 'react';
import { Redirect, Link } from 'react-router-dom';
import { notification, Layout, Row, Col, Typography } from 'antd';

import LoginForm from './LoginForm';

import './Login.scss';
import { useTranslation } from 'react-i18next';

import { AuthConsumer } from 'shared/contexts/AuthContext';
import API_SERVICE from '../../services/api-service';
import Parameters from '../../parameters';

const { Content } = Layout;

interface Props {
    location: any;

}

const { Title } = Typography;

export default function Login({ location }: Props) {
    const { t } = useTranslation();
    const [fields, setFields] = useState([] as any[]);
    const [loading, setLoading] = useState(false);

    const { from } = location.state || { from: { pathname: '/' } };
    let settings = null as any;
    if (localStorage.getItem('settings')) {
        settings = JSON.parse(localStorage.getItem('settings') as string);
    }
    return (
        <AuthConsumer>
            {({ isAuth, updateAuthToken }) =>
                isAuth ? (
                    <Redirect to={from}/>
                ) : (
                    <div className='container-fluid'>
                        <div className='frontend-site-login' style={{paddingTop: '10%'}}>
                     {/* <Layout style={{ height: '100vh' }}>
                         <Content style={{ height: '100vh' }}>
                             <Row gutter={20} className="login">
                                 <Col flex={'auto'}/>
                                 <Col flex={'400px'} className="login-form-wrapper"> */}
                                    {/* <Title level={2}>{Parameters.ClientName}</Title> */}
                                    <Title level={2} className="text-center text-uppercase">{t('genDict.login')}</Title>
                                    <LoginForm
                                        onChange={setFields}
                                        fields={fields}
                                        onLogin={async (email: string, password: string) => {
                                            setLoading(true);
                                            try {
                                                const { data } = await API_SERVICE.login(email, password);
                                                updateAuthToken(data.data);
                                            } catch (e) {
                                                notification.error({
                                                    message: t(API_SERVICE.handleErrors(e)),
                                                });
                                            }
                                            setLoading(false);
                                        }}
                                        loading={loading}
                                    />
                                    <Row gutter={20}>
                                        {
                                            Parameters.Mode === 'CLIENT' && !settings.is_closed && <Col flex={24} className='text-center'>
                                                    <Link to="/register" className='text-blue'>
                                                        <u>{t('genDict.applyNow')}</u>
                                                    </Link>
                                                </Col>
                                                
                                        }
                                        {/* <Col>
                                           <Link to="/reset-password">
                                               {t('genDict.resetPassword')}
                                           </Link>
                                        </Col> */}
                                    </Row>
                                 {/* </Col>
                             </Row>
                         </Content>
                     </Layout> */}
                    </div>
                    </div>
                )
            }
        </AuthConsumer>
    );
}
